import { useEffect } from 'react';
import useClientAccounts from '#shared/components/Contacts/hooks/useClientAccounts';

// The client account a detail view renders. Each host (client-account page,
// contact drawer) calls this once and passes the result into the detail
// components, so the page header and the tabs share one instance.
// `skip` is set when a host injects its own instance into ContactDetailView —
// the internal copy then stays inert (no mount fetch).
export default function useClientAccountDetailData(accountID: string, { skip }: { skip?: boolean } = {}) {
  const { clientAccount, fetchClientAccount } = useClientAccounts();

  async function refreshClientAccount() {
    return fetchClientAccount(accountID);
  }

  useEffect(() => {
    if (skip) return;

    fetchClientAccount(accountID).catch(() => {
      // Logged by the hook; the view renders its empty state.
    });
  }, []);

  return { clientAccount, refreshClientAccount };
}

export type ClientAccountDetailData = ReturnType<typeof useClientAccountDetailData>;
